// Module for sending destination req payloads plus transforming them

import { DestinationReqPayload } from './types';

export const DestinationReqManger = {
  /**
   * Function which sends the destination req payload to the /destination-req endpoint
   * in order to save in db
   * @param: destination req payload
   * @returns object confirming success of request
   */
  sendDestReqPayloads: async (
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _destinationReqPayload: DestinationReqPayload,
  ): Promise<{ success: boolean }> => ({ success: true }),
};
